import { types } from "mobx-state-tree";

export const MainNotificationStore = types
  .model("MainNotificationStore", {
    mainNotification: types.maybe(types.string)
  })
  .actions((self) => ({
    setMainNotification(text: string) {
      self.mainNotification = text;
    }
  }));
